export class ClipsList {
  public clips: SubClip[] = [];

  add(
    text: string,
    start: number,
    end: number,
    stopReason?: string,
    words?: { text: string; startTime: number; endTime: number }[]
  ): void {
    if (text.trim().length < 1) {
      console.warn("Text is empty", text, start, end);
      return;
    }
    this.clips.push({
      startTime: start,
      endTime: end,
      duration: end - start,
      text: text.trim(),
      mergeCounter: 0,
      stopReason: stopReason,
      words: words ?? [],
    });
  }
}

export class WordBuffer {
  public text: string = "";
  public words: { text: string; startTime: number; endTime: number }[] = [];
  public duration: number = 0;
  public start: number = 0;
  public end: number = 0;

  flush(): {
    text: string;
    duration: number;
    start: number;
    end: number;
    words: { text: string; startTime: number; endTime: number }[];
  } {
    const result = {
      text: this.text.trim(),
      duration: this.duration,
      start: this.start,
      end: this.end,
      words: this.words,
    };
    this.words = [];
    this.text = "";
    this.duration = 0;
    this.start = 0;
    this.end = 0;
    return result;
  }

  add(word: { word: string; start: number; end: number }): void {
    if (word.word.trim().length < 1) {
      throw new Error("Word is empty");
    }
    this.text += word.word.trim() + " ";
    this.words.push({
      text: word.word.trim(),
      startTime: word.start,
      endTime: word.end,
    });
    this.end = word.end;
    if (this.start === 0) {
      this.start = word.start;
    }
    this.duration = this.end - this.start;
  }
}

export const DEFAULT_CLIPS_CONFIG = {
  stopCharacters: [".", "?", "!"],
  maxDurationS: 2,
  splitAfterGapS: 0.5,
  maxChars: 50,
  originalSegments: false,
  wordHighlights: true,
  textPreviewMs: 0,
};

const splitTextIntoWords = ({ text }: { text: string }) => {
  return text.split(" ").filter((x) => !!x);
};

export const getWordsFromSegment = ({
  text,
  start,
  end,
}: {
  text: string;
  start: number;
  end: number;
}) => {
  const words = splitTextIntoWords({ text });

  const segmentDuration = end - start;
  const wordDuration = segmentDuration / words.length;
  return words.map((word, i) => {
    return {
      text: word.trim(),
      startTime: start + i * wordDuration,
      endTime: start + (i + 1) * wordDuration,
    };
  });
};
